import { axiosInstance } from '@services/base-service';

const usersUri = '/merchant/bff/user';
const guestsUri = '/merchant/bff/guest';

export const getUsers = () => axiosInstance.getInstance().get(`${usersUri}/merchant/users/list`);

export const getUser = (id) => axiosInstance.getInstance().get(`${usersUri}/merchant/users/${id}`);

export const getUserProfile = () => axiosInstance.getInstance().get(`${usersUri}/merchant/profile`);

export const updateUserProfile = (userProfile) =>
  axiosInstance.getInstance().post(`${usersUri}/merchant/profile`, { payload: userProfile });

export const createUser = (user) =>
  axiosInstance.getInstance().post(`${usersUri}/user/profile`, { payload: user });

export const validateEmail = (email) =>
  axiosInstance.getInstance().post(`${usersUri}/merchant/users/check-email`, {
    payload: { email },
  });

export const resendEmail = (email) =>
  axiosInstance.getInstance().post(`${usersUri}/resend/invitation`, { payload: { email } });

export const validateTokenResetPassword = (token) =>
  axiosInstance.getInstance().get(`${guestsUri}/validate/${token}`);

export const resetPassword = (data) =>
  axiosInstance.getInstance().post(`${guestsUri}/confirm`, { payload: data });

export const update = (data) =>
  axiosInstance.getInstance().post(`${usersUri}/user/update-profile`, { payload: data });

export const updatePhone = (data) =>
  axiosInstance.getInstance().post(`${usersUri}/user/update-phones`, { payload: data });

export const setUserState = (user, action) =>
  axiosInstance.getInstance().post(`${usersUri}/user/unsubscribe`, {
    payload: {
      status: action,
      id_user: user._id,
    },
  });

export const deleteUser = (user, action) =>
  axiosInstance.getInstance().post(`${usersUri}/user/deleted`, {
    payload: {
      status: action,
      id_user: user._id,
    },
  });

export const updateUserRole = ({ idUser, roles }, callbackSuccess, callbackError) => {
  try {
    axiosInstance
      .getInstance()
      .post(`${usersUri}/user/access`, {
        payload: { id_user: idUser, roles },
      })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const getOpscore = (sellerId) =>
  axiosInstance.getInstance().get(`${usersUri}user/opscore/${sellerId}`);
